// src/components/common/CustomFilters.tsx

import React from 'react';
import {
  TextInput,
  AutocompleteInput,
  DateInput,
  TextInputProps,
  AutocompleteInputProps,
  DateInputProps
} from 'react-admin';
import { filterFieldSx } from './filterStyles';

// Cast around a React-Admin/React 18 JSX return-type mismatch (TS2786).
const AutocompleteFilterInput = AutocompleteInput as React.ComponentType<AutocompleteInputProps>;

// Custom TextInput filter
export const CustomTextInputFilter: React.FC<TextInputProps> = (props) => {
  return (
    <TextInput
      size="small"
      variant="outlined"
      helperText={false}
      {...props}
      sx={[filterFieldSx, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
    />
  );
};

// Custom "select" filter — an autocomplete so the user can TYPE to filter the
// options, not just pick from a dropdown. Works standalone (choices) and inside
// a ReferenceInput.
export const CustomSelectInputFilter: React.FC<AutocompleteInputProps> = (props) => {
  return (
    <AutocompleteFilterInput
      size="small"
      variant="outlined"
      helperText={false}
      {...props}
      sx={[filterFieldSx, { minWidth: 180 }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
    />
  );
};

// Custom DateInput filter
export const CustomDateInputFilter: React.FC<DateInputProps> = (props) => {
  return (
    <DateInput
      size="small"
      variant="outlined"
      helperText={false}
      {...props}
      sx={[filterFieldSx, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
    />
  );
};
